/**
 * Pure bucket selection for the library grid: maps the requested content
 * types to the matching bucket streamed by useSimpleMediaLibrary.
 */

import type { MediaItem } from "@/core/MediaItem/MediaItem.model";
import type { MediaContentType } from "@/core/types/mediaContentType";

export interface LibraryBuckets {
  images: MediaItem[];
  shortVideos: MediaItem[];
  longVideos: MediaItem[];
  videos: MediaItem[];
  postVideos: MediaItem[];
  audio: MediaItem[];
}

export function selectLibraryItems(
  contentTypes: MediaContentType[],
  buckets: LibraryBuckets,
): MediaItem[] {
  if (contentTypes.includes("photos")) return buckets.images;
  if (contentTypes.includes("stories")) return buckets.shortVideos;
  if (contentTypes.includes("reels")) return buckets.longVideos;
  if (contentTypes.includes("videos")) return buckets.videos;
  if (contentTypes.includes("post_video")) return buckets.postVideos;
  if (contentTypes.includes("audio")) return buckets.audio;
  return [];
}
